<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small :title="'گزارش صورتحساب های صادر شده از طریق کیف پول'" color="accent">

			<AgentFactors ref="agentFactor" @add="add" @edit="edit" @remove="remove" userType='admin' :autoSubmit="autoSubmit" :hideDateRange="hideDateRange" :member="member" :agent="agent" />


			<v-dialog v-model="dialogModify" scrollable max-width="500px">
				<AgentFactorModify v-if="dialogModify" @close="dialogModify = false" @print="print" :data="selectedItem" userType='admin' />
			</v-dialog>

		</material-card>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import AgentFactors from '@/components/forms/AgentFactors.vue'

	export default {
		name: 'AgentFactorsView',
		props: {
			autoSubmit: { type: Boolean, default: false },
			hideDateRange: { type: Boolean, default: false },
			member: { type: Object },
			agent: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			AgentFactors: AgentFactors,
			AgentFactorModify: () => import('@/components/forms/AgentFactorModify'),
		},
		data() {
			return {
				selectedItem: null,
				errorMessages: '',
				dialogModify: false
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			add(item) {
				this.selectedItem = item
				this.dialogModify = true
			},
			edit(item) {
				this.selectedItem = item
				this.dialogModify = true
			},
			remove(item) {

			},
			print(item) {
				this.$refs.agentFactor.print(item)
			}
		},
	}
</script>
<style></style>
